// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2vZeF","inputWrap":"Table_inputWrap__36GEq","col":"Table_col__2GxhT","bmiTooltip":"Table_bmiTooltip__1Krrb"};